<template>
  <filter-bar
    label="Task"
    :filter-text="filterText"
    :reset="resetFilters"
  >
    <filter-item v-if="this.$store.getters.authUser.can_access_all_task">
      <filter-users
        filter-name="tasks"
        store-module="upNext"
        @change="reloadTasks('usersFilterText', $event)"
      ></filter-users>
    </filter-item>

    <filter-item>
      <filter-temperatures
        filter-name="tasks"
        store-module="upNext"
        @change="reloadTasks('temperaturesFilterText', $event)"
      ></filter-temperatures>
    </filter-item>

    <filter-item>
      <filter-deal-probability-score
        store-module="upNext"
        filter-name="tasks"
        @change="reloadTasks('dealProbabilityScoreText', $event)"
      ></filter-deal-probability-score>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Tag"
        v-model="filterTaskTagValue"
      >
        <option :value="0">All Tags</option>
        <option
          v-for="option in taskTags"
          :value="option.id"
          :key="option.id"
        >{{ option.label }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <filter-required
        filter-name="tasks"
        store-module="upNext"
        @change="reloadTasks('requiredFilterText', $event)"
      ></filter-required>
    </filter-item>
  </filter-bar>
</template>

<script>
import FilterRequired from "../../../components/filter/FilterRequired";
export default {
  name: "UpNextTaskFilter",
  components: {FilterRequired},
  data() {
    return {
      filterStateReady: false,
      usersFilterText: null,
      temperaturesFilterText: null,
      dealProbabilityScoreText: null,
      requiredFilterText: null,
    };
  },
  mounted() {
    // prevents multiple call on reloadTasks before data is ready
    // reason for this is we call reloadTasks on filter @change event
    this.filterStateReady = true;
  },
  computed: {
    taskTags() {
      return this.$store.getters.taskTags;
    },
    filterTaskTagValue: {
      get() {
        return this.$store.state['upNext'].filters['tasks'].tag;
      },
      set(value) {
        this.$store.commit("upNext/setOneFilter", [
          'tasks',
          "tag",
          value
        ]);
      }
    },
    taskTagText() {
      if (this.filterTaskTagValue !== 0 || this.filterTaskTagValue !== null) {
        const tag = this.taskTags.find(tag => tag.id === this.filterTaskTagValue);
        if (tag) return "Only Tasks Has Tag " + tag.label
      }

      return null
    },
    filterText() {
      let array = [];

      if (this.usersFilterText) array.push(this.usersFilterText);
      if (this.temperaturesFilterText) array.push(this.temperaturesFilterText);
      if (this.dealProbabilityScoreText) array.push(this.dealProbabilityScoreText);
      if (this.taskTagText) array.push(this.taskTagText);
      if (this.requiredFilterText) array.push(this.requiredFilterText);

      return array.join(" | ");
    }
  },
  methods: {
    reloadTasks(property, $event) {
      this[property] = $event;

      if (this.filterStateReady) {
        this.$emit('reloadTasks');
      }
    },
    resetFilters() {
      this.usersFilterText = null;
      this.temperaturesFilterText = null;
      this.dealProbabilityScoreText = null;
      this.requiredFilterText = null;
      this.filterTaskTagValue = 0;

      this.$store.commit("upNext/resetTasksFilters");

      this.$emit('reloadTasks');
    },
  }
};
</script>
